import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import qmStyles from '../theme/qmStyles';
import { checkValidKey } from '../util/util';

class FormInput extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    onSubmit: PropTypes.func,

    ref: PropTypes.object,

    placeholder: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    error: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    style: PropTypes.object,
    borderColor: PropTypes.string,
    errorBorderColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    hideBorder: PropTypes.bool,
    autocomplete: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string,
  };

  static defaultProps = {
    onChange: undefined,
    onSubmit: undefined,

    backgroundColor: qmStyles.white,
    borderColor: qmStyles.borderColor,
    errorBorderColor: 'red',
    textColor: qmStyles.greyDarkest,
    hideBorder: false,
    error: false,
    disabled: false,
    required: false,
    type: 'text',
    autocomplete: 'on',
    label: undefined,
  };

  onKeyPress = e => {
    const { onSubmit } = this.props;
    if (!onSubmit) return;
    if (checkValidKey(e.keyCode)) {
      onSubmit();
    }
  };

  renderInput = additionalProps => {
    const {
      style,
      borderColor,
      error,
      errorBorderColor,
      textColor,
      backgroundColor,
      disabled,
      value,
      placeholder,
      onChange,
      type,
      required,
      onSubmit,
      innerRef,
      pattern,
      title,
      hideBorder,
      autocomplete,
      name,
    } = this.props;

    return (
      <input
        required={required}
        pattern={pattern}
        title={title}
        style={{
          paddingLeft: qmStyles.gutter,
          paddingRight: qmStyles.gutter,
          WebkitAppearance: 'none',
          height: 40,
          fontSize: 14,
          justifyContent: 'center',
          borderRadius: qmStyles.borderRadius,
          borderColor: error ? errorBorderColor : borderColor,
          borderWidth: hideBorder ? 0 : 1,
          color: textColor,
          backgroundColor,
          ...style,
        }}
        ref={innerRef}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        name={name}
        type={type}
        disabled={disabled}
        onClick={onSubmit}
        onKeyPress={this.onKeyPress}
        autoComplete={autocomplete}
        {...additionalProps}
      />
    );
  };

  render() {
    const { label } = this.props;

    if (!isEmpty(label)) {
      const forId = makeIdFromLabel(label);
      return (
        <>
          <label
            className="self-start text-14 font-normal color-grey-darkest"
            htmlFor={forId}
          >
            {label}
          </label>
          {this.renderInput({ id: forId })}
        </>
      );
    }
    return this.renderInput();
  }
}

export default React.forwardRef((props, ref) => (
  <FormInput innerRef={ref} {...props} />
));

// for now we assume there are no duplicate labels in the same form
const makeIdFromLabel = label => label.replace(' ', '_');
